module.exports = __webpack_public_path__ + "static/img/data_analysis.78166bb6.jpg";